function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 11.5,
  fill: "#425CD4",
  stroke: "white"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M12.9836 12.9836C12.7212 13.237 12.3697 13.3773 12.0049 13.3741C11.6402 13.3709 11.2912 13.2246 11.0332 12.9667C10.7753 12.7087 10.629 12.3597 10.6258 11.9949C10.6226 11.6302 10.7629 11.2787 11.0163 11.0163C11.5596 10.473 16.6733 7.32935 16.6733 7.32935C16.6733 7.32935 13.5304 12.4403 12.9836 12.9836Z",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M12.9836 12.9836C12.7212 13.237 12.3697 13.3773 12.0049 13.3741C11.6402 13.3709 11.2912 13.2246 11.0332 12.9667C10.7753 12.7087 10.629 12.3597 10.6258 11.9949C10.6226 11.6302 10.7629 11.2787 11.0163 11.0163C11.5596 10.473 16.6733 7.32935 16.6733 7.32935C16.6733 7.32935 13.5304 12.4403 12.9836 12.9836Z",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M6.08691 12H7.13039",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M6.08691 12H7.13039",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M7.81921 7.81909L8.55661 8.55648",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M7.81921 7.81909L8.55661 8.55648",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M12 6.08691V7.13039",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M12 6.08691V7.13039",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M17.9131 12H16.8696",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M17.9131 12H16.8696",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M18.0056 17.2869C16.2425 16.0701 14.1419 15.4375 12.0001 15.4782C9.85823 15.4375 7.75765 16.0701 5.99451 17.2869",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M18.0056 17.2869C16.2425 16.0701 14.1419 15.4375 12.0001 15.4782C9.85823 15.4375 7.75765 16.0701 5.99451 17.2869",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z",
  stroke: "white",
  strokeWidth: 0.9,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z",
  stroke: "white",
  strokeWidth: 0.9,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M12.9836 12.9836C12.7212 13.237 12.3697 13.3773 12.0049 13.3741C11.6402 13.3709 11.2912 13.2246 11.0332 12.9667C10.7753 12.7087 10.629 12.3597 10.6258 11.9949C10.6226 11.6302 10.7629 11.2787 11.0163 11.0163C11.5596 10.473 16.6733 7.32935 16.6733 7.32935C16.6733 7.32935 13.5304 12.4403 12.9836 12.9836Z",
  stroke: "white",
  strokeWidth: 0.9,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M12.9836 12.9836C12.7212 13.237 12.3697 13.3773 12.0049 13.3741C11.6402 13.3709 11.2912 13.2246 11.0332 12.9667C10.7753 12.7087 10.629 12.3597 10.6258 11.9949C10.6226 11.6302 10.7629 11.2787 11.0163 11.0163C11.5596 10.473 16.6733 7.32935 16.6733 7.32935C16.6733 7.32935 13.5304 12.4403 12.9836 12.9836Z",
  stroke: "white",
  strokeWidth: 0.9,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M6.08691 12H7.13039",
  stroke: "white",
  strokeWidth: 0.9,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M6.08691 12H7.13039",
  stroke: "white",
  strokeWidth: 0.9,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M7.81921 7.81909L8.55661 8.55648",
  stroke: "white",
  strokeWidth: 0.9,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M7.81921 7.81909L8.55661 8.55648",
  stroke: "white",
  strokeWidth: 0.9,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M12 6.08691V7.13039",
  stroke: "white",
  strokeWidth: 0.9,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M12 6.08691V7.13039",
  stroke: "white",
  strokeWidth: 0.9,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M17.9131 12H16.8696",
  stroke: "white",
  strokeWidth: 0.9,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M17.9131 12H16.8696",
  stroke: "white",
  strokeWidth: 0.9,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M18.0056 17.2869C16.2425 16.0701 14.1419 15.4375 12.0001 15.4782C9.85823 15.4375 7.75765 16.0701 5.99451 17.2869",
  stroke: "white",
  strokeWidth: 0.9,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M18.0056 17.2869C16.2425 16.0701 14.1419 15.4375 12.0001 15.4782C9.85823 15.4375 7.75765 16.0701 5.99451 17.2869",
  stroke: "white",
  strokeWidth: 0.9,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgComfortSensor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComfortSensor);
export default __webpack_public_path__ + "static/media/comfort-sensor.ffb1f89bf34ccebbbd285077321463d3.svg";
export { ForwardRef as ReactComponent };